import BasePage from "@Scripts/Pages/BasePage";

export default class HomePage extends BasePage {
    public static async init() {
        await super.init();
        this.setMarketStrip();
    }

    private static setMarketStrip() {
        let marketStrip = document.getElementById("MarketStrip"),
            intViewportHeight = window.innerHeight - 170;

        if (marketStrip) {
            if (window.scrollY > intViewportHeight) {
                marketStrip.setAttribute("data-sticky", "");
            }

            window.addEventListener("scroll", function () {
                if (window.scrollY > intViewportHeight) {
                    marketStrip.setAttribute("data-sticky", "");
                } else {
                    marketStrip.removeAttribute("data-sticky");
                }
            });
        }
    }
}